import { ICategory } from "@faire/web-api--source/indigofair/data/ICategory";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";
import { ISuggestedBrand } from "@faire/web-api--source/indigofair/data/ISuggestedBrand";
import { ISuggestedProduct } from "@faire/web-api--source/indigofair/data/ISuggestedProduct";

import ISearchRecommendation = ISearchSuggestionResponse.ISearchRecommendation;
import ISearchQueryWithFilters = ISearchSuggestionResponse.ISearchQueryWithFilters;

type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

export type ISearchSuggestionResponseKeys = keyof ISearchSuggestionResponse;

export type ISuggestionSearchDataType = ISuggestedBrand &
  ISuggestedProduct &
  ISearchRecommendation &
  ICategory &
  ISearchQueryWithFilters &
  IFlattenedSearchProductsRequest;

namespace ISuggestionSearchDataType {
  export const build = (
    partial?: Partial<ISuggestionSearchDataType> | undefined
  ): ISuggestionSearchDataType => {
    return partial as ISuggestionSearchDataType;
  };
}

export type ISuggestionEntry<
  T extends
    | Partial<ISuggestionSearchDataType>
    | string = Partial<ISuggestionSearchDataType>,
> = {
  label: string;
  url: string;
  sectionName: string;
  searchData: T;
  requestID?: string;
};

type SearchSuggestionResponseItemType<
  Type extends ISearchSuggestionResponseKeys,
> = ISearchSuggestionResponse[Type] extends unknown[]
  ? ArrayElement<ISearchSuggestionResponse[Type]>
  : ISearchSuggestionResponse[Type];

export interface ITypedSuggestionEntry<
  Type extends ISearchSuggestionResponseKeys,
> extends ISuggestionEntry {
  searchKey?: Type;
  typedSearchData?: SearchSuggestionResponseItemType<Type>;
}

export type ISuggestionEntryMixin<
  T extends
    | Partial<ISuggestionSearchDataType>
    | string = Partial<ISuggestionSearchDataType>,
> = ISuggestionEntry<T> & ITypedSuggestionEntry<ISearchSuggestionResponseKeys>;

export namespace ISuggestionEntry {
  export const build = (
    partial?: Partial<ISuggestionEntry> | undefined
  ): ISuggestionEntry => ({
    label: partial?.label ?? "",
    url: partial?.url ?? "",
    sectionName: partial?.sectionName ?? "",
    searchData: ISuggestionSearchDataType.build(partial?.searchData),
    requestID: partial?.requestID ?? "",
  });
}

export interface IFlattenedSearchProductsRequest {
  category_display_name: string | undefined;
  category_key: string | undefined;
  query: string | undefined;
  queryKey: string | undefined;
  categories: string[];
}
